module.exports = __webpack_public_path__ + "static/media/logo.c226439e.png";